import {del, get, patch, post} from './http'

export const getSupplierList = (params) => get('goodsmanual/supplier/list', params)

export const addSupplier = (params) => post('goodsmanual/supplier', params)

export const editSupplier = (supplierId, params) => patch('goodsmanual/supplier/' + supplierId, params)

export const getSupplierDetail = (supplierId) => get('goodsmanual/supplier/' + supplierId, {})

export const delSuppliers = (supplierIdList) => del('goodsmanual/supplier', {supplierIdList: supplierIdList})

export const getSuppliertypeList = () => get('goodsmanual/supplier/type/list', {})
